function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { AppBar } from "@sprout/client-components/dist/AppBar";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { NotFound } from "@sprout/views";
import BottomNavigation from "@sprout/client-components/dist/BottomNavigation";
import admin from "@sprout/client-lib/dist/admin";
import useScrollManager from "@sprout/hooks/dist/useScrollManager";
import { assignmentsPageRoutes, featureRoutes, landingPageRoutes, noNavigationBottomRoutes, postPageRoutes, searchPageRoutes, topicPageRoutes, welcomePageRoutes } from "@sprout/client-routes";
import { useIsWelcomePageOnboard } from "@sprout/hooks/dist/onboard";
import useSpecialTopic from "@sprout/hooks/dist/useSpecialTopic";
import { AccountPage, ActivityPage, AdminPage, AgendaPage, AmendmentPage, ArchivePage, AssignmentsPage, BillingHistoryPage, BillingPage, BillingPeriodPage, FollowingPage, DefaultTreePage, HomePage, InviteCodePage, InviteUsersPage, LoginPage, NewTeamPage, NewTopicPage, NotificationSettingsHomePage, NotificationSettingsPage, NotificationsPage, PaymentPage, PostActivityPage, PostDraftPage, PostPage, SearchPage, SettingsPage, ShortcutsPage, StartPage, TeamsPage, TopicMembersPage, TopicNotificationsPage, TopicSettingsPage, TopicPage, TopicsPage, TrashPage, UnsubscribePage, WorkspaceUpgradePage, PublicPage, PoliciesPage, PricingPage, RecentPage, FeaturesPage, FocusWhenPage, ProfilePageUser, ProfilePageFollowers, ProfilePageFollowing, ProfilePageTeamMembers, ProfilePagePosts, PrioritiesPage, FeaturePage, EditProfilePage, DraftsPage, WelcomePage } from "..";
import ProtectedRoute from "./ProtectedRoute";
const AppRoutes = ()=>{
    var ref;
    const currentUser = useCurrentUser();
    const startPage = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.userSetting) === null || ref === void 0 ? void 0 : ref.startPage;
    useScrollManager();
    const [isWelcomePageOnboard] = useIsWelcomePageOnboard();
    const { myTasksURL , readLaterURL  } = useSpecialTopic();
    const isLandingPage = !!useRouteMatch({
        exact: true,
        path: landingPageRoutes
    });
    const isWelcomePage = !!useRouteMatch({
        exact: true,
        path: welcomePageRoutes
    });
    if (currentUser && !isLandingPage && !isWelcomePage && !isWelcomePageOnboard && process.env.NODE_ENV !== "test") return /*#__PURE__*/ _jsx(Redirect, {
        to: "/welcome"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                /*#__PURE__*/ _jsx(Route, {
                    exact: true,
                    path: [
                        "/login",
                        "/signup"
                    ],
                    render: (props)=>{
                        if (!currentUser) return /*#__PURE__*/ _jsx(LoginPage, _objectSpread({}, props));
                        return /*#__PURE__*/ _jsx(Redirect, {
                            to: "/"
                        });
                    }
                }),
                /*#__PURE__*/ _jsx(ProtectedRoute, {
                    exact: true,
                    path: "/admin",
                    conditions: [
                        {
                            condition: !!admin(currentUser),
                            ifFail: "/"
                        }, 
                    ],
                    component: AdminPage
                }),
                /*#__PURE__*/ _jsx(Route, {
                    path: "/optout",
                    component: UnsubscribePage
                }),
                /*#__PURE__*/ _jsxs(Route, {
                    path: "*",
                    children: [
                        /*#__PURE__*/ _jsx(AppBar, {}),
                        /*#__PURE__*/ _jsxs(Switch, {
                            children: [
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: welcomePageRoutes,
                                    component: WelcomePage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/",
                                    render: ()=>{
                                        if (!currentUser) return /*#__PURE__*/ _jsx(PublicPage, {});
                                        return /*#__PURE__*/ _jsx(Redirect, {
                                            to: startPage || "/home"
                                        });
                                    }
                                }),
                                "`",
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/(terms|privacy|copyright|trademark|community)",
                                    component: PoliciesPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/amendment-to-sprout-terms-of-service-applicable-to-u-s-government-users",
                                    component: AmendmentPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/pricing",
                                    component: PricingPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: featureRoutes,
                                    component: FeaturePage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/features",
                                    component: FeaturesPage
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/today",
                                    to: "/trees"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/read-later",
                                    to: readLaterURL
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/inbox",
                                    to: readLaterURL
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/my-tasks",
                                    to: myTasksURL
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/new-topic",
                                    to: "/new-tree"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/new-post",
                                    to: "/new-leaf"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/post/drafts",
                                    to: "/drafts"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/post/:postId(\\d+)",
                                    to: "/leaf/:postId(\\d+)"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/post/:postId(\\d+)/draft",
                                    to: "/leaf/:postId(\\d+)/draft"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/post/:postId(\\d+)/activity",
                                    to: "/leaf/:postId(\\d+)/activity"
                                }),
                                /*#__PURE__*/ _jsx(Redirect, {
                                    exact: true,
                                    from: "/invite/:context(topic|team)/:code/:topicTitle([^\\s\\/]+)",
                                    to: "/invite/:context(tree|workspace)/:code/:topicTitle([^\\s\\/]+)"
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/home",
                                    component: HomePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/payment",
                                    component: PaymentPage,
                                    toSignUpInstead: true
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/new-workspace",
                                    component: NewTeamPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/new-tree",
                                    component: NewTopicPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/trash",
                                    component: TrashPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/archived",
                                    component: ArchivePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/following",
                                        "/following/:username"
                                    ],
                                    component: FollowingPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/activity",
                                    component: ActivityPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/notifications",
                                    component: NotificationsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: assignmentsPageRoutes,
                                    component: AssignmentsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/recent",
                                    component: RecentPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/my/workspaces",
                                    component: TeamsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/my/start-page",
                                    component: StartPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/shortcuts",
                                    component: ShortcutsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/select-a-team-to-upgrade",
                                    component: WorkspaceUpgradePage,
                                    toSignUpInstead: true
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/trees",
                                    component: TopicsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/default-tree",
                                    component: DefaultTreePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/:focusWhen(bookmarks)",
                                    component: FocusWhenPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/priorities",
                                    component: PrioritiesPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: searchPageRoutes,
                                    component: SearchPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/:username/invite",
                                        "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)/invite", 
                                    ],
                                    component: InviteUsersPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/invite/:context(tree|workspace)/:code/:topicTitle([^\\s\\/]+)",
                                    component: InviteCodePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/edit-profile",
                                        "/:workspace/edit-profile"
                                    ],
                                    component: EditProfilePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/(billing|payment-method)",
                                        "/:workspace/(billing|payment-method)", 
                                    ],
                                    component: BillingPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/billing-period",
                                        "/:workspace/billing-period"
                                    ],
                                    component: BillingPeriodPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/billing-history",
                                        "/:workspace/billing-history"
                                    ],
                                    component: BillingHistoryPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/settings",
                                        "/:workspace/settings"
                                    ],
                                    component: SettingsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/my/notifications",
                                    component: NotificationSettingsHomePage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/my/:notification(email-notifications|browser-notifications)",
                                    component: NotificationSettingsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: [
                                        "/my/account",
                                        "/:workspace/account"
                                    ],
                                    component: AccountPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/drafts",
                                    component: DraftsPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: [
                                        "/agenda",
                                        "/:username/agenda"
                                    ],
                                    component: AgendaPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:username",
                                    component: ProfilePageUser
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: [
                                        "/:username/leaves",
                                        "/:username/workspace/leaves"
                                    ],
                                    component: ProfilePagePosts
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:username/followers",
                                    component: ProfilePageFollowers
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:username/following",
                                    component: ProfilePageFollowing
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:username/members",
                                    component: ProfilePageTeamMembers
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: topicPageRoutes,
                                    component: TopicPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)/trash",
                                    component: TopicPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)/members",
                                    component: TopicMembersPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)/settings",
                                    component: TopicSettingsPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)/notifications",
                                    component: TopicNotificationsPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: postPageRoutes,
                                    component: PostPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/leaf/:postId(\\d+)/draft",
                                    component: PostDraftPage
                                }),
                                /*#__PURE__*/ _jsx(ProtectedRoute, {
                                    exact: true,
                                    path: "/leaf/:postId(\\d+)/activity",
                                    component: PostActivityPage
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "*",
                                    component: NotFound
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: noNavigationBottomRoutes,
                            children: ({ match  })=>match || !currentUser || !isWelcomePageOnboard ? null : /*#__PURE__*/ _jsx(BottomNavigation, {})
                        })
                    ]
                })
            ]
        })
    });
};
export default AppRoutes;
